import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatChipsModule } from '@angular/material/chips';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDividerModule } from '@angular/material/divider';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { QRCodeModule } from 'angularx-qrcode';
import { ColorThemingDirective } from '../core/directives/color-theming.directive';

import {
    FontAwesomeModule,
    FaIconLibrary
} from '@fortawesome/angular-fontawesome';
import {
    faBars,
    faUserCircle,
    faUserPlus,
    faUserEdit,
    faUserCog,
    faUsers,
    faUserGroup,
    faUserCheck,
    faBuilding,
    faSitemap,
    faPowerOff,
    faCog,
    faPlayCircle,
    faRocket,
    faPlus,
    faEdit,
    faTrash,
    faTimes,
    faCaretUp,
    faCaretDown,
    faExclamationTriangle,
    faFilter,
    faTasks,
    faCheck,
    faSquare,
    faLanguage,
    faPaintBrush,
    faLightbulb,
    faWindowMaximize,
    faMinus,
    faStream,
    faBook,
    faHome,
    faChartLine,
    faDollarSign,
    faKey,
    faLevelUpAlt,
    faBolt,
    faCity,
    faUpload,
    faArrowRight,
    faArrowLeft,
    faArrowDown,
    faArrowUp,
    faSearch,
    faWrench,
    faInfo,
    faInfoCircle,
    faBan,
    faTimesCircle,
    faChevronCircleDown,
    faChevronCircleRight,
    faSort,
    faFloppyDisk,
    faPlusCircle,
    faPencilAlt,
    faEllipsis,
    faEllipsisV,
    faMailBulk,
    faEnvelope,
    faEnvelopeOpen,
    faExpandAlt,
    faCompressAlt,
    faMobile,
    faMobileAlt,
    faRss,
    faRssSquare,
    faWindowClose,
    faPaperPlane,
    faChevronLeft,
    faChevronRight,
    faChevronDown,
    faFileAlt,
    faFileDownload,
    faFileArrowUp,
    faFileCsv,
    faFileCircleCheck,
    faClock,
    faStar,
    faCopy,
    faArrowCircleRight,
    faArrowCircleLeft,
    faCheckSquare,
    faAddressCard,
    faCamera,
    faCreditCard,
    faLink,
    faArrowCircleDown,
    faQuestionCircle,
    faChevronUp,
    faRefresh,
    faTriangleExclamation,
    faReply,
    faReplyAll,
    faShare,
    faComment,
    faLandmark,
    faHouse,
    faBriefcase,
    faFileInvoiceDollar,
    faHouseUser,
    faAddressBook,
    faCircle,
    faCircleUser,
    faLock,
    faFolderOpen,
    faBomb,
    faA,
    faFileSignature,
    faMoneyBill,
    faFileLines,
    faEye,
    faEyeSlash,
    faXmark,
    faCaretLeft,
    faCaretRight,
    IconDefinition,
    faExpand,
    faBoxArchive,
    faListCheck,
    faCheckCircle,
    faChevronCircleUp
} from '@fortawesome/free-solid-svg-icons';

import {
    faCircle as farCircle,
    faCircleCheck as farCircleCheck,
    faCheckSquare as farCheckSquare,
    faSquare as farSquare,
    faEnvelope as farEnvelope
} from '@fortawesome/free-regular-svg-icons';

import {
    faBarsFilter,
    faPaperclip,
    faMemoCircleInfo,
    faArrowRotateLeft,
    faSquareUser,
    faLandmarkMagnifyingGlass,
    faCircleDollar,
    faArrowUpRight,
    faArrowDownRight,
    faArrowRightFromBracket,
    faArrowUpLeft,
    faBuildings,
    faCommentQuestion,
    faOctagonCheck,
    faOctagonXmark,
    faBellRing
} from '@fortawesome/pro-solid-svg-icons';

// kxk: todo - Add Pro Regular Icon Library

// import {
//     faMemoCircleInfo
// } from '@fortawesome/pro-regular-svg-icons';

import {
    faGithub,
    faMediumM,
    faTwitter,
    faXTwitter,
    faThreads,
    faInstagram,
    faLinkedin,
    faYoutube,
    faFacebook,
    faYelp,
    faGoogle,
    faCcVisa,
    faCcMastercard,
    faCcAmex,
    faCcJcb,
    faCcDinersClub,
    faCcDiscover
} from '@fortawesome/free-brands-svg-icons';

import {
    faArrowUpLong as farArrowUpLong,
    faArrowDownLong as farArrowDownLong,
    faBoxArchive as farBoxArchive,
    faArrowRotateLeft as farArrowRotateLeft,
    faCalculatorSimple as farCalculatorSimple,
    faSitemap as farSitemap,
    faLockKeyhole,
    faCircleInfo
} from '@fortawesome/pro-regular-svg-icons';

import { BigInputComponent } from './big-input/big-input/big-input.component';
import { BigInputActionComponent } from './big-input/big-input-action/big-input-action.component';
import { GenericFooterComponent } from '../shared/footers/generic-footer/generic-footer.component';
import { MortgageFooterComponent } from './footers/mortgage-footer/mortgage-footer.component';
import { CCMFooterComponent } from './footers/ccm-footer/ccm-footer.component';
import { LoadingIndicatorComponent } from './loading-indicator/loading-indicator.component';
import { LgvGridManager } from './grid-manager/grid-manager';
import { LgvGridHeaderComponent } from './grid-manager/grid-header.component';
import { LgvGridPagerComponent } from './grid-manager/grid-pager.component';
import { ClientReportComponent } from './client-report/client-report.component';
import { RouterModule } from '@angular/router';
import { NumericInputComponent } from './numeric-input/numeric-input.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { LgvUTCDatePipe2 } from './pipes/utc-date.pipe2';
import { UserSearchComponent } from './user-search/user-search.component';
import { UsersComponent } from '../modules/admin/pages/users/users.component';
import { ModalFormComponent } from './modal-form/modal-form.component';
import { OrganizationSearchComponent } from './organization-search/organization-search.component';
import { CompanySelectComponent } from './company-select/company-select.component';
import { AgentSearchComponent } from './agent-search/agent-search.component';
import { AppNameDisplayComponent } from './app-name-display/app-name-display.component';
import { EditLoanPopup } from '../modules/client/controls/edit-loan-popup/edit-loan-popup.component';
import { ActivityModalComponent } from './activity-modal/activity-modal.component';
import { ClientSearchComponent } from './client-search/client-search.component';
import { PublicRecordResultComponent } from './public-record-result/public-record-result.component';
import { EditLoanComponent } from './edit-loan/edit-loan.component';
import { CreateLoanComponent } from './create-loan/create-loan.component';
import { CurrentYearComponent } from './current-year/current-year.component';
import { ConfirmEmailInvitationModalComponent } from './confirm-email-invitation-modal/confirm-email-invitation-modal.component';
import { ConfirmEmailLoginLinkModalComponent } from './confirm-login-link-modal/confirm-login-link-modal.component';
import { ClientPickerComponent } from './client-picker/client-picker.component';
import { ClientPickerModalComponent } from './client-picker-modal/client-picker-modal.component';
import { LgvDefaultAgentImagePipe } from './pipes/default-agent-image.pipe';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSliderModule } from '@angular/material/slider';
import { MatStepperModule } from '@angular/material/stepper';
import { LgvExpander } from './lgv-expander/lgv-expander.component';
import { LgvABSPipe } from './pipes/abs.pipe';
import { PopupMgr } from './popup-mgr/popup-mgr.component';
import {
    MatProgressBar,
    MatProgressBarModule
} from '@angular/material/progress-bar';
import { AddPropertyModalComponent } from './add-property-modal/add-property-modal.component';
import { NullPipe } from './pipes/null.pipe';
import { ProspectPropertyStatusComponent } from './prospect-property-status/prospect-property-status.component';
import { PropertyDetailCardComponent } from './property-detail-card/property-detail-card.component';
import { EditLoanScenarioModalComponent } from './edit-loan-scenario-modal/edit-loan-scenario-modal.component';
import { LoanScenarioFormComponent } from './loan-scenario-form/loan-scenario-form.component';
import { AddressValidationDialogComponent } from './address-validation-dialog/address-validation-dialog.component';
import { AgentCard } from './agent-card/agent-card.component';
import { AgentFooter } from './agent-footer/agent-footer.component';
import { AgentPartnerRow } from './agent-partner-row/agent-partner-row.component';
import { EmailPopup } from './email-popup/email-popup.component';
import { LgvPhoneNumberPipe, SortByPipe } from '../core/core.module';
import { HomeValueEstimationWidgetComponent } from './home-value-estimation-widget/home-value-estimation-widget.component';
import { AvmPopUpComponent } from './avm-popup/avm-popup.component';
import { AddressAutoCompleteComponent } from './address-auto-complete/address-auto-complete.component';
import { BuyerMissingInfoModal } from './buyer-missing-info-modal/buyer-missing-info-modal.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ImageUploaderModalComponent } from './image-uploader-modal/image-uploader-modal.component';
import { ColorPickerComponent, ColorPickerModule } from 'ngx-color-picker';
import { CompanyEditModalComponent } from './company-edit-modal/company-edit-modal.component';
import { SocialMediaEditModalComponent } from './social-media-edit-modal/social-media-edit-modal.component';
import { SocialMediaIconComponent } from './social-media-icon/social-media-icon.component';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { UserEditModalComponent } from './user-edit-modal/user-edit-modal.component';
import { DisclaimersModalComponent } from './disclaimers-modal/disclaimers-modal.component';
import { CompanyCopyrightComponent } from './company-copyright/company-copyright.component';
import { BillingModalComponent } from './billing-modal/billing-modal.component';
import { UserInviteModalComponent } from './user-invite-modal/user-invite-modal.component';
import { PricingPreferencesModalComponent } from './pricing-preferences-modal/pricing-preferences-modal.component';
import { EmailCampainDialogComponent } from './email-campain-dialog/email-campain-dialog.component';
import { CurrentLienWidgetComponent } from './current-lien-widget/current-lien-widget.component';
import { UniversalFooterComponent } from './footers/universal-footer/universal-footer.component';
import { AgentOnboardingBanner } from './agent-onboarding-banner/agent-onboarding-banner.component';
import { LgvExpanderV2 } from './lgv-expander-v2/lgv-expander-v2.component';
import { EditPpeOriginationIDComponent } from './edit-ppe-origination-id/edit-ppe-origination-id.component';
import { LoanAppFormComponent } from './loan-app-form/loan-app-form.component';
import { AdjustHomeValueDialogComponent } from './adjust-home-value-dialog/adjust-home-value-dialog.component';
import { CustomValuationDialogComponent } from './custom-valuation-dialog/custom-valuation-dialog.component';
import { ApplyNowBtnComponent } from './apply-now-btn/apply-now-btn.component';
import { EditClientProfileComponent } from './edit-client-profile/edit-client-profile.component';
import { MatInputWithCommaDirective } from '../core/directives/mat-input-with-comma.directive';
import { EditUserConfigModalComponent } from './edit-user-config-modal/edit-user-config-modal.component';
import { CreateAccountModalComponent } from './create-account-modal/create-account-modal.component';
import { QuickPricerComponent } from './quick-pricer/quick-pricer.component';
import { LongUrlNavigatorComponent } from './long-url-navigator/long-url-navigator.component';
import { EditScenarioModalComponent } from '../features/pricing/dialogs/edit-scenario-modal/edit-scenario-modal.component';
import { PricingScenarioViewerComponent } from './pricing-scenario-viewer/pricing-scenario-viewer.component';
import { LockRequestModalComponent } from './lock-request-modal/lock-request-modal.component';
import { PublicRecordsModalComponent } from './public-records-modal/public-records-modal.component';
import { StartLoanModalComponent } from './start-loan-modal/start-loan-modal.component';
import { LoanAppTaskModalComponent } from './loan-app-task-modal/loan-app-task-modal.component';
import { LoanAppVaultModalComponent } from './loan-app-vault-modal/loan-app-vault-modal.component';
import { UploadDocumentModalComponent } from './upload-document-modal/upload-document-modal.component';
import { LoanAppTermsAndConditionsPageComponent } from './loan-app-terms-and-conditions-page/loan-app-terms-and-conditions-page.component';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FormlyNumericInputComponent } from './formly/formly-numeric-input/formly-numeric-input.component';
import { FormlyButtonComponent } from './formly/formly-button/formly-button.component';
import { FormlyAnchorTagComponent } from './formly/formly-anchor-tag/formly-anchor-tag.component';
import { FormlyRepeatingSectionComponent } from './formly/formly-repeating-section/formly-repeating-section.component';
import { FormNavigatorComponent } from './formly/form-navigator/form-navigator.component';
import { FormlyRepeatingSectionSummaryComponent } from './formly/formly-repeating-section-summary/formly-repeating-section-summary.component';
import { FormlyAddressAutopopulateComponent } from './formly/formly-address-autopopulate/formly-address-autopopulate.component';
import { FormlyLabelComponent } from './formly/formly-label/formly-label.component';
import { FormlyResidenceDurationComponent } from './formly/formly-residence-duration/formly-residence-duration.component';
import { FormlyLabelWithModalComponent } from './formly/formly-label-with-modal/formly-label-with-modal.component';
import { SectionSummaryComponent } from './formly/section-summary/section-summary.component';
import { FormlySSNInputComponent } from './formly/formly-ssn-input/formly-ssn-input.component';
import { SectionTitleNavigationComponent } from './formly/section-title-navigation/section-title-navigation.component';
import { FormlyDownPctAmtComponent } from './formly/formly-down-pct-amt/formly-down-pct-amt.component';
import { FormlyCurrencyInputComponent } from './formly/formly-currency-input/formly-currency-input.component';
import { FormlyPhoneNumberComponent } from './formly/formly-phone-number/formly-phone-number.component';
import { MatInputPhoneNumberDirective } from '../core/directives/mat-input-phone-number.directive';
import { BooleanPipe } from './pipes/boolean.pipe';
import { FormlyMultiSelectCheckboxComponent } from './formly/formly-multi-select-checkbox/formly-multi-select-checkbox.component';
import { DocumentViewerModalComponent } from './document-viewer-modal/document-viewer-modal.component';
import { ShortLoanAppPageComponent } from './short-loan-app-page/short-loan-app-page.component';
import { LoanAppTasksComponent } from './loan-app/loan-app-tasks/loan-app-tasks.component';
import { LoanAppDetailsComponent } from './loan-app/loan-app-details/loan-app-details.component';
import { LoanAppActivitiesComponent } from './loan-app/loan-app-activities/loan-app-activities.component';
import { LoanAppVaultComponent } from './loan-app/loan-app-vault/loan-app-vault.component';
import { LgvDateOrTimePipe } from './pipes/date-or-time.pipe';
import { ClientLoginLinkModalComponent } from './client-login-link-modal/client-login-link-modal.component';
import { LinkEmailToClientModalComponent } from './link-email-to-client-modal/link-email-to-client-modal.component';
import { AddDocToTaskModalComponent } from './add-doc-to-task-modal/add-doc-to-task-modal.component';
import { DebounceClickDirective } from '../core/directives/debounce-click.directive';
import { EConsentDialogComponent } from './loan-app/e-consent-dialog/e-consent-dialog.component';
import { AgentSignatureComponent } from './agent-signature/agent-signature.component';
import { RespaTriggerDialogComponent } from './loan-app/respa-trigger-dialog/respa-trigger-dialog.component';
import { ExitWarningDialogComponent } from './loan-app/exit-warning-dialog/exit-warning-dialog.component';
import { EmailInputComponent } from './email-input/email-input.component';
import { Icon } from '@fortawesome/fontawesome-svg-core';
import { CreditReportDialogComponent } from './loan-app/credit-report-dialog/credit-report-dialog.component';
import { CreditCardDirectivesModule } from 'angular-cc-library';
import { SsnInputComponent } from './loan-app/credit-report-dialog/ssn-input/ssn-input.component';
import { ClientPickerOrNewClientComponent } from '../features/pricing/dialogs/client-picker-or-new-client/client-picker-or-new-client.component';
import { TodaysRatesComponent } from './todays-rates/todays-rates.component';
import { MortgageRateHistoryComponent } from './mortgage-rate-history/mortgage-rate-history.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { RatesTodayAndHistoricalComboComponent } from './rates-today-and-historical-combo/rates-today-and-historical-combo.component';
import { LoanRefiCaclulatorComponent } from './loan-refi-calculator/loan-refi-calculator.component';
import { LoanMortgageCaclulatorComponent } from './loan-mortgage-calculator/loan-mortgage-calculator.component';
import { DebtIncomeCalculatorComponent } from './debt-income-calculator/debt-income-calculator.component';
import { MatTableModule } from '@angular/material/table';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NewClientDialogComponent } from './new-client-dialog/new-client-dialog.component';
import { CalculatorsWidgetComponent } from './calculators-widget/calculators-widget.component';
import { SplashDialogComponent } from './splash-dialog/splash-dialog.component';
import { PrelicenseBannerComponent } from './prelicense-banner/prelicense-banner.component';
import { PricingStatusInfoDialogComponent } from '../features/pricing/dialogs/pricing-status-info-dialog/pricing-status-info-dialog.component';
import { PricingStatusPillComponent } from '../features/pricing/components/pricing-status-pill/pricing-status-pill.component';
import { LinkToLoanDialogComponent } from '../features/pricing/dialogs/link-to-loan-dialog/link-to-loan-dialog.component';
import { LoanAppQuotesComponent } from './loan-app/loan-app-quotes/loan-app-quotes.component';
import { ScenarioInfoCardComponent } from '../features/pricing/components/scenario-info-card/scenario-info-card.component';
import { PricingQuotesCardListComponent } from '../features/pricing/components/pricing-quotes-card-list/pricing-quotes-card-list.component';
import { ClientPricingQuotesComponent } from '../features/pricing/pages/client-pricing-quotes/client-pricing-quotes.component';
import { OpportunityDisplayComponent } from '../features/pricing/components/opportunity-display/opportunity-display.component';
import { ContactAgentDialogComponent } from '../features/pricing/dialogs/contact-agent-dialog/contact-agent-dialog.component';
import { FileUploadBoxComponent } from './file-upload-box/file-upload-box.component';
import { LicenseEditModalComponent } from './license-edit-modal/license-edit-modal.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SharedDropdownModule } from './shared-dropdown.module';
import { PreApprovalStepperComponent } from '../features/steppers/components/stepper/pre-approval-stepper/pre-approval-stepper.component';
import { LoanAppPreApprovalComponent } from './loan-app/loan-app-pre-approval/loan-app-pre-approval.component';
import { StatusTrackerComponent } from '../features/pos/widgets/status-tracker/status-tracker.component';
import { StatusDetailDialogComponent } from '../features/pos/dialogs/status-detail-dialog/status-detail-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        DragDropModule,
        ReactiveFormsModule,
        TranslateModule,
        MatButtonModule,
        MatToolbarModule,
        MatSelectModule,
        MatTabsModule,
        MatStepperModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatChipsModule,
        MatCardModule,
        MatDialogModule,
        MatSidenavModule,
        MatCheckboxModule,
        MatListModule,
        MatMenuModule,
        MatAutocompleteModule,
        MatIconModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatSlideToggleModule,
        MatRadioModule,
        MatPaginatorModule,
        MatDividerModule,
        FontAwesomeModule,
        RouterModule,
        MatButtonToggleModule,
        MatExpansionModule,
        MatDatepickerModule,
        ImageCropperModule,
        ColorPickerModule,
        GooglePlaceModule,
        MatSliderModule,
        MatProgressBarModule,
        FormlyBootstrapModule,
        FormlyModule,
        QRCodeModule,
        CreditCardDirectivesModule,
        NgApexchartsModule,
        MatTableModule,
        ColorThemingDirective,
        MatFormFieldModule,
        MatNativeDateModule,
        SharedDropdownModule,
        PreApprovalStepperComponent
    ],
    declarations: [
        AgentCard,
        AgentFooter,
        AgentPartnerRow,
        AgentOnboardingBanner,
        EmailPopup,
        HomeValueEstimationWidgetComponent,
        AvmPopUpComponent,
        BigInputComponent,
        BigInputActionComponent,
        GenericFooterComponent,
        CCMFooterComponent,
        MortgageFooterComponent,
        UniversalFooterComponent,
        AppNameDisplayComponent,
        LoadingIndicatorComponent,
        LgvGridHeaderComponent,
        LgvGridPagerComponent,
        UserSearchComponent,
        ClientReportComponent,
        UserProfileComponent,
        LgvPhoneNumberPipe,
        SortByPipe,
        LgvUTCDatePipe2,
        LgvDateOrTimePipe,
        LgvDefaultAgentImagePipe,
        LgvABSPipe,
        LgvExpander,
        LgvExpanderV2,
        NumericInputComponent,
        ConfirmationDialogComponent,
        ClientPickerModalComponent,
        ModalFormComponent,
        OrganizationSearchComponent,
        CompanySelectComponent,
        AgentSearchComponent,
        EditLoanPopup,
        ActivityModalComponent,
        LinkEmailToClientModalComponent,
        ClientSearchComponent,
        PublicRecordResultComponent,
        EditLoanComponent,
        CreateLoanComponent,
        ConfirmEmailInvitationModalComponent,
        ConfirmEmailLoginLinkModalComponent,
        CurrentYearComponent,
        CompanyCopyrightComponent,
        ClientPickerComponent,
        AddPropertyModalComponent,
        PopupMgr,
        NullPipe,
        AddressValidationDialogComponent,
        ProspectPropertyStatusComponent,
        PropertyDetailCardComponent,
        BuyerMissingInfoModal,
        EditLoanScenarioModalComponent,
        LoanScenarioFormComponent,
        AddressAutoCompleteComponent,
        EmailCampainDialogComponent,
        ImageUploaderModalComponent,
        UserProfileComponent,
        CompanyEditModalComponent,
        SocialMediaEditModalComponent,
        SocialMediaIconComponent,
        UserEditModalComponent,
        DisclaimersModalComponent,
        BillingModalComponent,
        UserInviteModalComponent,
        PricingPreferencesModalComponent,
        CurrentLienWidgetComponent,
        EditPpeOriginationIDComponent,
        LoanAppFormComponent,
        AdjustHomeValueDialogComponent,
        CustomValuationDialogComponent,
        EditClientProfileComponent,
        ApplyNowBtnComponent,
        MatInputWithCommaDirective,
        EditUserConfigModalComponent,
        CreateAccountModalComponent,
        QuickPricerComponent,
        LongUrlNavigatorComponent,
        EditScenarioModalComponent,
        PricingScenarioViewerComponent,
        LockRequestModalComponent,
        PublicRecordsModalComponent,
        StartLoanModalComponent,
        ClientPickerOrNewClientComponent,
        LoanAppTaskModalComponent,
        LoanAppVaultModalComponent,
        UploadDocumentModalComponent,
        FormlyNumericInputComponent,
        FormlySSNInputComponent,
        FormlyRepeatingSectionSummaryComponent,
        LoanAppTermsAndConditionsPageComponent,
        FormNavigatorComponent,
        SectionSummaryComponent,
        FormlyButtonComponent,
        FormlyAnchorTagComponent,
        FormlyRepeatingSectionComponent,
        FormlyAddressAutopopulateComponent,
        FormlyLabelComponent,
        FormlyResidenceDurationComponent,
        FormlyDownPctAmtComponent,
        FormlyLabelWithModalComponent,
        SectionTitleNavigationComponent,
        FormlyCurrencyInputComponent,
        FormlyPhoneNumberComponent,
        MatInputPhoneNumberDirective,
        BooleanPipe,
        FormlyMultiSelectCheckboxComponent,
        DocumentViewerModalComponent,
        ShortLoanAppPageComponent,
        LoanAppTasksComponent,
        LoanAppDetailsComponent,
        DebounceClickDirective,
        LoanAppActivitiesComponent,
        LoanAppPreApprovalComponent,
        LoanAppVaultComponent,
        LinkEmailToClientModalComponent,
        AddDocToTaskModalComponent,
        ClientLoginLinkModalComponent,
        EConsentDialogComponent,
        AgentSignatureComponent,
        RespaTriggerDialogComponent,
        ExitWarningDialogComponent,
        EmailInputComponent,
        CreditReportDialogComponent,
        SsnInputComponent,
        TodaysRatesComponent,
        MortgageRateHistoryComponent,
        RatesTodayAndHistoricalComboComponent,
        LoanRefiCaclulatorComponent,
        LoanMortgageCaclulatorComponent,
        DebtIncomeCalculatorComponent,
        NewClientDialogComponent,
        CalculatorsWidgetComponent,
        SplashDialogComponent,
        PrelicenseBannerComponent,
        PricingStatusInfoDialogComponent,
        PricingStatusPillComponent,
        LinkToLoanDialogComponent,
        PricingStatusInfoDialogComponent,
        LoanAppQuotesComponent,
        ScenarioInfoCardComponent,
        PricingQuotesCardListComponent,
        ClientPricingQuotesComponent,
        OpportunityDisplayComponent,
        ContactAgentDialogComponent,
        FileUploadBoxComponent,
        AgentSignatureComponent,
        AgentSignatureComponent,
        LicenseEditModalComponent,
        StatusTrackerComponent,
        StatusDetailDialogComponent
    ],
    exports: [
        MatButtonModule,
        MatToolbarModule,
        MatSelectModule,
        MatTabsModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatChipsModule,
        MatCardModule,
        MatSidenavModule,
        MatCheckboxModule,
        MatListModule,
        MatMenuModule,
        MatIconModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatSlideToggleModule,
        MatDividerModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatButtonToggleModule,
        MatAutocompleteModule,
        MatDialogModule,
        MatExpansionModule,
        MatPaginatorModule,
        MatFormFieldModule,
        AgentCard,
        AgentFooter,
        AgentPartnerRow,
        AgentOnboardingBanner,
        EmailPopup,
        HomeValueEstimationWidgetComponent,
        AvmPopUpComponent,
        CurrentYearComponent,
        CompanyCopyrightComponent,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        MatButtonModule,
        MatMenuModule,
        MatTabsModule,
        MatChipsModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatCheckboxModule,
        MatCardModule,
        MatDialogModule,
        MatSidenavModule,
        MatListModule,
        MatStepperModule,
        MatSelectModule,
        MatToolbarModule,
        MatIconModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatSlideToggleModule,
        MatDividerModule,
        MatSliderModule,
        MatRadioModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatAutocompleteModule,
        MatProgressBarModule,
        FontAwesomeModule,
        MatButtonToggleModule,
        MatExpansionModule,
        ColorPickerModule,
        BigInputComponent,
        BigInputActionComponent,
        GenericFooterComponent,
        CCMFooterComponent,
        MortgageFooterComponent,
        UniversalFooterComponent,
        LoadingIndicatorComponent,
        AppNameDisplayComponent,
        LgvGridHeaderComponent,
        LgvGridPagerComponent,
        LgvExpander,
        LgvExpanderV2,
        ClientReportComponent,
        UserSearchComponent,
        UserProfileComponent,
        NumericInputComponent,
        ConfirmationDialogComponent,
        ClientPickerModalComponent,
        ModalFormComponent,
        OrganizationSearchComponent,
        CompanySelectComponent,
        AgentSearchComponent,
        LgvPhoneNumberPipe,
        SortByPipe,
        LgvDefaultAgentImagePipe,
        LgvABSPipe,
        EditLoanPopup,
        ActivityModalComponent,
        LinkEmailToClientModalComponent,
        ClientSearchComponent,
        PublicRecordResultComponent,
        ConfirmEmailInvitationModalComponent,
        ConfirmEmailLoginLinkModalComponent,
        ClientPickerComponent,
        PopupMgr,
        NullPipe,
        AddressValidationDialogComponent,
        ProspectPropertyStatusComponent,
        LoanScenarioFormComponent,
        AddressAutoCompleteComponent,
        EmailCampainDialogComponent,
        SocialMediaIconComponent,
        CurrentLienWidgetComponent,
        CustomValuationDialogComponent,
        ApplyNowBtnComponent,
        MatInputWithCommaDirective,
        QuickPricerComponent,
        FormlyBootstrapModule,
        FormlyModule,
        LoanAppTermsAndConditionsPageComponent,
        FormNavigatorComponent,
        SectionSummaryComponent,
        FormlyLabelComponent,
        FormlyResidenceDurationComponent,
        FormlyDownPctAmtComponent,
        FormlyLabelWithModalComponent,
        FormlyCurrencyInputComponent,
        MatInputPhoneNumberDirective,
        BooleanPipe,
        FormlyMultiSelectCheckboxComponent,
        ShortLoanAppPageComponent,
        LoanAppTasksComponent,
        LoanAppDetailsComponent,
        LoanAppActivitiesComponent,
        LoanAppVaultComponent,
        LgvDateOrTimePipe,
        EConsentDialogComponent,
        DebounceClickDirective,
        RespaTriggerDialogComponent,
        AgentSignatureComponent,
        EmailInputComponent,
        CreditCardDirectivesModule,
        SsnInputComponent,
        TodaysRatesComponent,
        MortgageRateHistoryComponent,
        NgApexchartsModule,
        RatesTodayAndHistoricalComboComponent,
        LoanRefiCaclulatorComponent,
        LoanMortgageCaclulatorComponent,
        DebtIncomeCalculatorComponent,
        NgxChartsModule,
        PricingScenarioViewerComponent,
        NewClientDialogComponent,
        CalculatorsWidgetComponent,
        PrelicenseBannerComponent,
        PricingStatusInfoDialogComponent,
        PricingStatusPillComponent,
        LinkToLoanDialogComponent,
        LoanAppQuotesComponent,
        ScenarioInfoCardComponent,
        PricingQuotesCardListComponent,
        ClientPricingQuotesComponent,
        ContactAgentDialogComponent,
        ColorThemingDirective,
        FileUploadBoxComponent,
        LicenseEditModalComponent,
        SharedDropdownModule,
        StatusTrackerComponent,
        StatusDetailDialogComponent
    ]
})
export class SharedModule {
    constructor(library: FaIconLibrary) {
        library.addIcons(
            faBars,
            faUserCircle,
            faUserPlus,
            faUserEdit,
            faUserCog,
            faUsers,
            faUserGroup,
            faUserCheck,
            faPowerOff,
            faBuilding,
            faCog,
            faEye,
            faEyeSlash,
            faRocket,
            faPlayCircle,
            faGithub,
            faMediumM,
            faTwitter,
            faXTwitter,
            faThreads,
            faInstagram,
            faYoutube,
            faPlus,
            faMinus,
            faEdit,
            faTrash,
            faTimes,
            faCaretUp,
            faCaretDown,
            faCaretLeft,
            faCaretRight,
            faExclamationTriangle,
            faFilter,
            faTasks,
            faTimes,
            faTimesCircle,
            faCheck,
            faSquare,
            faLanguage,
            faPaintBrush,
            faLightbulb,
            faWindowMaximize,
            faStream,
            faBook,
            faYelp,
            faGoogle,
            faHome,
            faChartLine,
            faDollarSign,
            faKey,
            faLevelUpAlt,
            faBolt,
            faUpload,
            faArrowRight,
            faArrowLeft,
            faArrowUp,
            faArrowDown,
            faSearch,
            faEdit,
            faCity,
            faFacebook,
            faLinkedin,
            faWrench,
            faInfo,
            faInfoCircle,
            faBan,
            faChevronCircleDown,
            faChevronCircleUp,
            faChevronCircleRight,
            faSort,
            faFloppyDisk,
            faPlusCircle,
            faPencilAlt,
            faEllipsis,
            faEllipsisV,
            faMailBulk,
            faEnvelope,
            faEnvelopeOpen,
            faExpand,
            faExpandAlt,
            faCompressAlt,
            faMobile,
            faMobileAlt,
            faRss,
            faRssSquare,
            faWindowClose,
            faPaperPlane,
            faChevronLeft,
            faChevronRight,
            faChevronDown,
            faChevronUp,
            farCircle,
            farCheckSquare,
            farCircleCheck,
            faSquare,
            faCheckSquare,
            farSquare,
            farEnvelope,
            faFileAlt,
            faFileDownload,
            faFileArrowUp,
            faFileCsv,
            faFileCircleCheck,
            faClock,
            faHome,
            faStar,
            faCopy,
            faArrowCircleRight,
            faArrowCircleLeft,
            faAddressCard,
            faCamera,
            faCreditCard,
            faLink,
            faArrowCircleDown,
            faQuestionCircle,
            faRefresh,
            faTriangleExclamation,
            faReply,
            faReplyAll,
            faShare,
            faComment,
            faLandmark,
            faLock,
            faAddressBook,
            faCircleUser,
            faCircle,
            faBriefcase,
            faFileInvoiceDollar,
            faHouse,
            faHouseUser,
            faFolderOpen,
            faBomb,
            faFileSignature,
            faXmark,
            faMoneyBill,
            faPaperPlane,
            faCcDiscover,
            faCcVisa,
            faCcMastercard,
            faCcAmex,
            faCcJcb,
            faCcDinersClub,
            faCcDiscover,
            faListCheck,
            faCheckCircle,
            farCircleCheck,
            faTriangleExclamation,
            faFileInvoiceDollar,

            // pro icons need to cast as IconDefinition
            faOctagonXmark as IconDefinition,
            faSquareUser as IconDefinition,
            faBarsFilter as IconDefinition,
            faPaperclip as IconDefinition,
            faCircleInfo as IconDefinition,
            farArrowUpLong as IconDefinition,
            farArrowDownLong as IconDefinition,
            faMemoCircleInfo as IconDefinition,
            farArrowRotateLeft as IconDefinition,
            farBoxArchive as IconDefinition,
            farCalculatorSimple as IconDefinition,
            farSitemap as IconDefinition,

            faArrowRotateLeft as IconDefinition,
            faBoxArchive as IconDefinition,
            faLandmarkMagnifyingGlass as IconDefinition,
            faCircleDollar as IconDefinition,
            faArrowRightFromBracket as IconDefinition,
            faArrowUpRight as IconDefinition,
            faArrowDownRight as IconDefinition,
            faArrowUpLeft as IconDefinition,
            faBuildings as IconDefinition,
            faSitemap as IconDefinition,
            faCommentQuestion as IconDefinition,
            faLockKeyhole as IconDefinition,
            faBellRing as IconDefinition
        );
    }
}
